module.exports = {
      id: "jio-plain-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-c58a3b4628aec4c6d4a5f4fa9a2e0307.svg#jio-plain",
      toString: function () {
        return this.url;
      }
    }